/* eslint-disable linebreak-style */
import template from './index.pug'

export default Vue.extend({
  name: 'home-page',
  template: template(),
  
  data() {
    return {
      homeVideoUrl: HOME_VIDEO_URL
    }
  },

  computed: {
    showHomeVideo() {
      return !!this.homeVideoUrl
    },
    getVideosHome() {
      if (this.showHomeVideo) {
        return this.homeVideoUrl.replace(/\s/g, '').split(',')
      }

      return null
    }
  },

  mounted(){
    /** @todo refactor with $refs */
    const boton = document.getElementById('botonRecarga');

    var left = this
    // Agregar un listener para el evento focus
    boton.addEventListener('focus', function() {
      left.escucharAudio(left.$t('textoVoz.botonRecarga'))
    });
  },

  methods: {
    goToRecharge() {
      this.$router.push({name: 'recharge'})
    },
  }
})
